import { BrowserRouter } from 'react-router-dom';
import { useUnit } from 'effector-react';
import { $notificationStore, $remoteConfigStore, NotificationType } from '@lib/store';
import { cn } from '@shared/utils';
import { Root } from '@routes';
import { ColorsEnum, Text } from '@shared/widgets';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'react-datepicker/dist/react-datepicker.css';

export const App = () => {
  const notification = useUnit($notificationStore.store);
  const remoteConfig = useUnit($remoteConfigStore.store);

  const versionToConsole = remoteConfig.data['version_to_console']?.asBoolean();
  versionToConsole && console.log('Version of the app:', process.env.BUILD_DATE);

  return (
    <BrowserRouter>
      {notification?.message && (
        <div
          className={cn('fixed left-0 right-0 top-0 z-[50000] w-dvw border bg-white dark:bg-soft-black', [
            notification.type === NotificationType.ERROR && 'border-red',
            notification.type === NotificationType.WARNING && 'border-primary',
            notification.type === NotificationType.SUCCESS && 'border-green',
          ])}
        >
          <Text className='p-3 text-center' weight='semibold' color={getColor(notification.type)}>
            {notification.message}
          </Text>
        </div>
      )}
      <Root />
    </BrowserRouter>
  );
};

const getColor = (type: NotificationType) => {
  switch (type) {
    case NotificationType.ERROR:
      return ColorsEnum.Red;
    case NotificationType.WARNING:
      return ColorsEnum.Primary;
    case NotificationType.SUCCESS:
      return ColorsEnum.Green;
    default:
      return;
  }
};
